module.exports = __webpack_public_path__ + "img/02.2cb7f16c.jpg";